"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledSnackWhen = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _colors = _interopRequireDefault(require("@fe/ui/colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SnackWhen = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SnackWhen, _React$PureComponent);

  var _super = _createSuper(SnackWhen);

  function SnackWhen() {
    var _this;

    _classCallCheck(this, SnackWhen);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: true
    });

    return _this;
  }

  _createClass(SnackWhen, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.test && nextProps.test !== this.props.test) {
        this.setState({
          show: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          type = _this$props.type,
          classes = _this$props.classes;
      return /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
        onClose: function onClose(e, reason) {
          return _this2.setState({
            show: !(type === 'confirmation' || reason === 'clickaway')
          });
        },
        autoHideDuration: type === 'confirmation' ? 5000 : null,
        open: this.props.test && this.state.show,
        anchorOrigin: {
          vertical: this.props.top ? 'top' : 'bottom',
          horizontal: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement(_SnackbarContent.default, {
        className: type === 'error' ? classes.error : type === 'warning' ? classes.warning : type === 'confirmation' ? classes.confirmation : classes.default,
        message: this.props.children
      }));
    }
  }]);

  return SnackWhen;
}(_react.default.PureComponent);

_defineProperty(SnackWhen, "propTypes", {
  test: _propTypes.default.bool.isRequired,
  selector: _propTypes.default.func.isRequired,
  children: _propTypes.default.string.isRequired,
  top: _propTypes.default.bool,
  type: _propTypes.default.string
});

_defineProperty(SnackWhen, "defaultProps", {
  top: false,
  type: 'loading'
});

var StyledSnackWhen = (0, _withStyles.default)(function (theme) {
  return {
    close: {
      width: theme.spacing(1) * 4,
      height: theme.spacing(1) * 4
    },
    default: {
      backgroundColor: _colors.default.businessBlue,
      color: _colors.default.white
    },
    confirmation: {
      backgroundColor: _colors.default.pieLightBlue,
      color: _colors.default.white
    },
    error: {
      backgroundColor: _colors.default.primaryRed,
      color: _colors.default.white
    },
    warning: {
      backgroundColor: _colors.default.primaryOrange,
      color: _colors.default.white
    }
  };
})(SnackWhen);
exports.StyledSnackWhen = StyledSnackWhen;

var _default = (0, _reactRedux.connect)(function (s, _ref) {
  var selector = _ref.selector;
  return {
    test: Boolean(selector(s))
  };
})(StyledSnackWhen);

exports.default = _default;